/**
 * 認証関連のヘルパー関数
 */

/**
 * ローカルストレージにトークンを保存
 */
export const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem('access_token', accessToken);
  if (refreshToken) {
    localStorage.setItem('refresh_token', refreshToken);
  }
};

/**
 * ローカルストレージからトークンを取得
 */
export const getTokens = () => {
  return {
    accessToken: localStorage.getItem('access_token'),
    refreshToken: localStorage.getItem('refresh_token'),
  };
};

/**
 * トークンをクリア
 */
export const clearTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
};

/**
 * ローカルストレージにユーザー情報を保存
 */
export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

/**
 * ローカルストレージからユーザー情報を取得
 */
export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

/**
 * ユーザー情報をクリア
 */
export const clearUser = () => {
  localStorage.removeItem('user');
};

/**
 * ログイン状態をチェック
 */
export const isAuthenticated = () => {
  const { accessToken } = getTokens();
  return !!accessToken;
};

/**
 * 管理者かどうかチェック
 */
export const isAdmin = () => {
  const user = getUser();
  return user?.role === 'admin';
};

/**
 * ユーザーの企業IDを取得
 */
export const getCurrentCompanyId = () => {
  const user = getUser();
  return user?.company_id;
};

/**
 * ユーザーIDを取得
 */
export const getCurrentUserId = () => {
  const user = getUser();
  return user?.user_id;
};

/**
 * ログアウト処理
 */
export const logout = () => {
  clearTokens();
  clearUser();
};
